import { render } from "./AuthProviderWarningBanners.vue?vue&type=template&id=85a0a500&scoped=true&ts=true"
import script from "./AuthProviderWarningBanners.vue?vue&type=script&lang=ts"
export * from "./AuthProviderWarningBanners.vue?vue&type=script&lang=ts"

import "./AuthProviderWarningBanners.vue?vue&type=style&index=0&id=85a0a500&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a0a500"]])

export default __exports__